import React from 'react';
// helpers/constants
import * as G from '../../../../helpers';
import * as GC from '../../../../constants';
import { getGroupedByCountryStateOptionsByConfig } from '../../../../helpers/options';
// feature dispatch-report
import { TableField } from '../../components/table-fields';
//////////////////////////////////////////////////

export const columnSettings = {
  [GC.FIELD_PRIMARY_REFERENCE_VALUE]: {
    width: 250,
    name: 'titles:clo-number',
  },
  [GC.GRC.FIRST_EVENT_LOCATION_NAME]: {
    width: 200,
    name: ['titles:first-event', 'titles:location-name'],
  },
  [GC.GRC.FIRST_EVENT_LOCATION_CITY]: {
    width: 200,
    name: ['titles:first-event', 'titles:city'],
  },
  [GC.GRC.FIRST_EVENT_LOCATION_STATE]: {
    width: 200,
    type: 'state',
    name: ['titles:first-event', 'titles:state'],
  },
  [GC.GRC.FIRST_EVENT_EARLY_DATE]: {
    width: 200,
    name: ['titles:first-event', 'titles:early-date'],
  },
  [GC.GRC.LAST_EVENT_LOCATION_NAME]: {
    width: 200,
    name: ['titles:last-event', 'titles:location-name'],
  },
  [GC.GRC.LAST_EVENT_LOCATION_CITY]: {
    width: 200,
    name: ['titles:last-event', 'titles:city'],
  },
  [GC.GRC.LAST_EVENT_LOCATION_STATE]: {
    width: 200,
    type: 'state',
    name: ['titles:last-event', 'titles:state'],
  },
  [GC.FIELD_STORED_TOTAL_WEIGHT]: {
    width: 200,
    name: 'titles:total-weight',
    customComponent: (data) => <TableField data={data} type={GC.FIELD_WEIGHT} />,
  },
  [GC.FIELD_TOTAL_PICKUP_QUANTITY]: {
    width: 200,
    name: 'titles:quantity',
  },
  [GC.GRC.COST_ALLOCATION_TEL_PRIMARY_REFERENCE_VALUE]: {
    width: 200,
    sortable: false,
    searchable: false,
    name: 'titles:tel-number',
  },
  [GC.GRC.COST_ALLOCATION_TEL_TOTAL_PICKUP_QUANTITY]: {
    width: 200,
    sortable: false,
    searchable: false,
    name: ['titles:tel', 'titles:pickup-quantity'],
  },
  [GC.GRC.COST_ALLOCATION_TEL_STORED_TOTAL_WEIGHT]: {
    width: 200,
    sortable: false,
    searchable: false,
    name: ['titles:tel', 'titles:total-weight'],
  },
  [GC.GRC.COST_ALLOCATION_TEL_FLEET_ASSIGNMENT_PRIMARY_DRIVER_FULL_NAME]: {
    width: 200,
    sortable: false,
    searchable: false,
    name: ['titles:tel', 'titles:primary-driver'],
  },
  [GC.GRC.COST_ALLOCATION_TEL_RATE_DISPATCHED_OR_CANCELED_BY]: {
    width: 200,
    sortable: false,
    searchable: false,
    name: ['titles:tel', 'titles:dispatched-or-canceled-by'],
  },
  [GC.GRC.PINNED_NOTE_TEXT]: {
    width: 200,
    name: 'titles:pinned-note',
  },
  [GC.GRC.TELS_PRIMARY_REF_VALUE]: {
    width: 200,
    name: ['titles:tels', 'titles:tel-number'],
  },
  [GC.GRC.TELS_FIRST_EVENT_EARLY_DATE]: {
    width: 200,
    name: ['titles:tels', 'titles:first-event', 'titles:early-date'],
  },
  [GC.GRC.TELS_FIRST_EVENT_LATE_DATE]: {
    width: 200,
    name: ['titles:tels', 'titles:first-event', 'titles:late-date'],
  },
  [GC.GRC.TELS_LAST_EVENT_EARLY_DATE]: {
    width: 200,
    name: ['titles:tels', 'titles:last-event', 'titles:early-date'],
  },
  [GC.GRC.TELS_LAST_EVENT_LATE_DATE]: {
    width: 200,
    name: ['titles:tels', 'titles:last-event', 'titles:late-date'],
  },
};

export const FILTER_PARAMS = [
  {
    type: 'string',
    value: GC.FIELD_PRIMARY_REFERENCE_VALUE,
    name: G.getWindowLocale('titles:clo-number', 'Order #'),
  },
  {
    type: 'string',
    value: GC.GRC.FIRST_EVENT_LOCATION_NAME,
    name: `${G.getWindowLocale('titles:first-event', 'First Event')}: ${
      G.getWindowLocale('titles:location-name', 'Location Name')}`,
  },
  {
    type: 'string',
    value: GC.GRC.FIRST_EVENT_LOCATION_CITY,
    name: `${G.getWindowLocale('titles:first-event', 'First Event')}: ${
      G.getWindowLocale('titles:city', 'City')}`,
  },
  {
    type: 'selectMultipleCreatable',
    value: GC.GRC.FIRST_EVENT_LOCATION_STATE,
    options: getGroupedByCountryStateOptionsByConfig,
    name: `${G.getWindowLocale('titles:first-event', 'First Event')}: ${
      G.getWindowLocale('titles:state', 'State')}`,
  },
  {
    type: 'date',
    value: GC.GRC.FIRST_EVENT_EARLY_DATE,
    name: `${G.getWindowLocale('titles:first-event', 'First Event')}: ${
      G.getWindowLocale('titles:early-date', 'Early Date')}`,
  },
  {
    type: 'string',
    value: GC.GRC.LAST_EVENT_LOCATION_NAME,
    name: `${G.getWindowLocale('titles:last-event', 'Last Event')}: ${
      G.getWindowLocale('titles:location-name', 'Location Name')}`,
  },
  {
    type: 'string',
    value: GC.GRC.LAST_EVENT_LOCATION_CITY,
    name: `${G.getWindowLocale('titles:last-event', 'Last Event')}: ${
      G.getWindowLocale('titles:city', 'City')}`,
  },
  {
    type: 'selectMultipleCreatable',
    value: GC.GRC.LAST_EVENT_LOCATION_STATE,
    options: getGroupedByCountryStateOptionsByConfig,
    name: `${G.getWindowLocale('titles:last-event', 'Last Event')}: ${
      G.getWindowLocale('titles:state', 'State')}`,
  },
  {
    type: 'number',
    value: GC.FIELD_STORED_TOTAL_WEIGHT,
    name: G.getWindowLocale('titles:total-weight', 'Total Weight'),
  },
  {
    type: 'number',
    value: GC.FIELD_TOTAL_PICKUP_QUANTITY,
    name: G.getWindowLocale('titles:quantity', 'Quantity'),
  },
  {
    type: 'string',
    disableSort: true,
    disableFilter: true,
    name: G.getWindowLocale('titles:tel-number', 'Trip #'),
    value: GC.GRC.COST_ALLOCATION_TEL_PRIMARY_REFERENCE_VALUE,
  },
  {
    type: 'number',
    disableSort: true,
    disableFilter: true,
    value: GC.GRC.COST_ALLOCATION_TEL_TOTAL_PICKUP_QUANTITY,
    name: `${G.getWindowLocale('titles:tel', 'Trip')}: ${
      G.getWindowLocale('titles:pickup-quantity', 'Pickup Quantity')}`,
  },
  {
    type: 'number',
    disableSort: true,
    disableFilter: true,
    value: GC.GRC.COST_ALLOCATION_TEL_STORED_TOTAL_WEIGHT,
    name: `${G.getWindowLocale('titles:tel', 'Trip')}: ${G.getWindowLocale('titles:total-weight', 'Total Weight')}`,
  },
  {
    type: 'string',
    disableSort: true,
    disableFilter: true,
    value: GC.GRC.COST_ALLOCATION_TEL_FLEET_ASSIGNMENT_PRIMARY_DRIVER_FULL_NAME,
    name: `${G.getWindowLocale('titles:tel', 'Trip')}: ${G.getWindowLocale('titles:primary-driver', 'Primary Driver')}`,
  },
  {
    type: 'string',
    disableSort: true,
    disableFilter: true,
    value: GC.GRC.COST_ALLOCATION_TEL_RATE_DISPATCHED_OR_CANCELED_BY,
    name: `${G.getWindowLocale('titles:tel', 'Trip')}: ${
      G.getWindowLocale('titles:dispatched-or-canceled-by', 'Dispatched Or Canceled By')}`,
  },
  {
    type: 'string',
    value: GC.GRC.PINNED_NOTE_TEXT,
    name: G.getWindowLocale('titles:pinned-note', 'Pinned Note'),
  },
  {
    type: 'string',
    collection: true,
    value: GC.GRC.TELS_PRIMARY_REF_VALUE,
    name: G.getWindowLocale('titles:tels', 'Tels'),
  },
  {
    type: 'date',
    collection: true,
    value: GC.GRC.TELS_FIRST_EVENT_EARLY_DATE,
    name: `${G.getWindowLocale('titles:tels', 'Tels')}: ${G.getWindowLocale('titles:first-event', 'First Event')}: ${
      G.getWindowLocale('titles:early-date', 'Early Date')}`,
  },
  {
    type: 'date',
    collection: true,
    value: GC.GRC.TELS_FIRST_EVENT_LATE_DATE,
    name: `${G.getWindowLocale('titles:tels', 'Tels')}: ${G.getWindowLocale('titles:first-event', 'First Event')}: ${
      G.getWindowLocale('titles:late-date', 'Late Date')}`,
  },
  {
    type: 'date',
    collection: true,
    value: GC.GRC.TELS_LAST_EVENT_EARLY_DATE,
    name: `${G.getWindowLocale('titles:tels', 'Tels')}: ${G.getWindowLocale('titles:last-event', 'Last Event')}: ${
      G.getWindowLocale('titles:early-date', 'Early Date')}`,
  },
  {
    type: 'date',
    collection: true,
    value: GC.GRC.TELS_LAST_EVENT_LATE_DATE,
    name: `${G.getWindowLocale('titles:tels', 'Tels')}: ${G.getWindowLocale('titles:last-event', 'Last Event')}: ${
      G.getWindowLocale('titles:late-date', 'Late Date')}`,
  },
];
